import { Content } from "../../squidex";

export class MenuModel extends Content {

    constructor(current?: Content) {
        super(current);
        if (current) {
            Object.assign(this, current);
        }
    }
}
